export const PATH_STREAM = 'stream';
export const PATH_INFO = 'info';
export const PATH_COOKIE = 'evasteet';
